module.exports = __webpack_public_path__ + "img/indonesia.9d8ebfcc.svg";